import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
import { mockData as users } from '@web/lib/demo/data/users';
import { filterData, getUsers } from '@web/lib/demo/utils';
import { DOCUMENT_SHARING_STATUS_ORDER, DocumentSharingStatusEnum, DriveEventActionEnum, DriveEventSubActionEnum } from '@workalizer/shared';
var getOrgUnitTitle = function (userId) {
    var _a, _b, _c, _d;
    var user = users.find(function (u) { return u.id === userId; });
    return (_d = (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.userOrgUnits) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.orgUnit) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : null;
};
var getUserById = function (userId) {
    var user = users.find(function (u) { return u.id === userId; });
    if (!user) {
        return null;
    }
    return {
        id: user.id,
        name: user.name,
        email: user.email,
        orgUnitTitle: getOrgUnitTitle(user.id)
    };
};
var PUBLIC_LINK_SUB_ACTIONS = new Set([
    DriveEventSubActionEnum.DOCUMENT_PEOPLE_WITH_LINK,
    DriveEventSubActionEnum.DOCUMENT_PUBLIC_IN_THE_DOMAIN,
    DriveEventSubActionEnum.DOCUMENT_PEOPLE_WITHIN_DOMAIN_WITH_LINK
]);
var getSharingStatuses = function (events) {
    var statuses = new Set();
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var event = events_1[_i];
        if (event.action === DriveEventActionEnum.DOCUMENT_PUBLISH) {
            statuses.add(DocumentSharingStatusEnum.PUBLIC_LINK);
            continue;
        }
        if (event.action !== DriveEventActionEnum.DOCUMENT_SHARE &&
            event.action !== DriveEventActionEnum.DOCUMENT_CHANGE_ACCESS) {
            continue;
        }
        if (!event.subAction) {
            continue;
        }
        if (event.subAction === DriveEventSubActionEnum.DOCUMENT_SHARED_INTERNALLY) {
            statuses.add(DocumentSharingStatusEnum.INTERNAL);
        }
        else if (event.subAction === DriveEventSubActionEnum.DOCUMENT_SHARED_EXTERNALLY) {
            statuses.add(DocumentSharingStatusEnum.EXTERNAL);
        }
        else if (PUBLIC_LINK_SUB_ACTIONS.has(event.subAction)) {
            statuses.add(DocumentSharingStatusEnum.PUBLIC_LINK);
        }
    }
    return DOCUMENT_SHARING_STATUS_ORDER.filter(function (status) { return statuses.has(status); });
};
export var documentsList = function (input) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var orgUnitUserIds = ((_a = input.filters) === null || _a === void 0 ? void 0 : _a.orgUnitId)
        ? getUsers({ orgUnitId: input.filters.orgUnitId }).map(function (user) { return user.id; })
        : null;
    var filteredEvents = filterData(documentEventsData, [
        {
            key: 'date',
            value: (_c = (_b = input.filters) === null || _b === void 0 ? void 0 : _b.dateFrom) !== null && _c !== void 0 ? _c : '',
            operator: 'gt',
            isSkip: !((_d = input.filters) === null || _d === void 0 ? void 0 : _d.dateFrom)
        },
        {
            key: 'date',
            value: (_f = (_e = input.filters) === null || _e === void 0 ? void 0 : _e.dateTo) !== null && _f !== void 0 ? _f : '',
            operator: 'lt',
            isSkip: !((_g = input.filters) === null || _g === void 0 ? void 0 : _g.dateTo)
        },
        {
            key: 'userId',
            value: (_j = (_h = input.filters) === null || _h === void 0 ? void 0 : _h.actionsBy) !== null && _j !== void 0 ? _j : 0,
            operator: 'eq',
            isSkip: !((_k = input.filters) === null || _k === void 0 ? void 0 : _k.actionsBy)
        },
        {
            key: 'userId',
            value: orgUnitUserIds !== null && orgUnitUserIds !== void 0 ? orgUnitUserIds : [],
            operator: 'in',
            isSkip: !((_l = input.filters) === null || _l === void 0 ? void 0 : _l.orgUnitId)
        },
        {
            key: 'document.title',
            value: (_o = (_m = input.filters) === null || _m === void 0 ? void 0 : _m.title) !== null && _o !== void 0 ? _o : '',
            operator: 'contains',
            isSkip: !((_p = input.filters) === null || _p === void 0 ? void 0 : _p.title)
        },
        {
            key: 'document.type',
            value: (_r = (_q = input.filters) === null || _q === void 0 ? void 0 : _q.type) !== null && _r !== void 0 ? _r : '',
            operator: 'eq',
            isSkip: !((_s = input.filters) === null || _s === void 0 ? void 0 : _s.type)
        },
        {
            key: 'action',
            value: (_u = (_t = input.filters) === null || _t === void 0 ? void 0 : _t.action) !== null && _u !== void 0 ? _u : '',
            operator: 'eq',
            isSkip: !((_v = input.filters) === null || _v === void 0 ? void 0 : _v.action)
        },
        {
            key: 'subAction',
            value: (_x = (_w = input.filters) === null || _w === void 0 ? void 0 : _w.subAction) !== null && _x !== void 0 ? _x : '',
            operator: 'eq',
            isSkip: !((_y = input.filters) === null || _y === void 0 ? void 0 : _y.subAction)
        }
    ]);
    var documentIds = Array.from(new Set(filteredEvents.map(function (event) { return event.document.id; })));
    var paginatedDocumentIds = input.offset !== undefined && input.limit !== undefined
        ? documentIds.slice(input.offset, input.offset + input.limit)
        : documentIds;
    var documents = paginatedDocumentIds
        .map(function (documentId) {
        var _a, _b;
        var scopedEvents = filteredEvents
            .filter(function (event) { return event.document.id === documentId; })
            .sort(function (a, b) { return new Date(b.date).getTime() - new Date(a.date).getTime(); });
        var document = (_a = scopedEvents[0]) === null || _a === void 0 ? void 0 : _a.document;
        if (!document) {
            return null;
        }
        var latestActivity = scopedEvents.find(function (event) { return event.action !== DriveEventActionEnum.DOCUMENT_VIEW; });
        var latestView = scopedEvents.find(function (event) { return event.action === DriveEventActionEnum.DOCUMENT_VIEW; });
        var createEvent = scopedEvents.find(function (event) { return event.action === DriveEventActionEnum.DOCUMENT_CREATE; });
        var ownerUserId = (_b = scopedEvents[0]) === null || _b === void 0 ? void 0 : _b.userId;
        var owner = ownerUserId ? getUserById(ownerUserId) : null;
        var mapActivity = function (event) {
            var _a, _b;
            var user = getUserById((_a = event === null || event === void 0 ? void 0 : event.userId) !== null && _a !== void 0 ? _a : 0);
            if (!event || !user) {
                return null;
            }
            return {
                date: event.date,
                action: event.action,
                subAction: (_b = event.subAction) !== null && _b !== void 0 ? _b : null,
                user: user
            };
        };
        return {
            id: document.id,
            title: document.title,
            type: document.type,
            slugId: document.slugId,
            owner: owner,
            created: mapActivity(createEvent),
            lastViewed: mapActivity(latestView),
            lastActivity: mapActivity(latestActivity),
            sharing: getSharingStatuses(scopedEvents)
        };
    })
        .filter(function (doc) { return doc !== null; });
    return {
        data: documents,
        total: documentIds.length
    };
};
